/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "../assets/scss/core/sections/_projects.scss";
import "bootstrap/dist/css/bootstrap.min.css";
// Pointing to the new JSON file
import upcomingData from "../data/upcomingprojects.json";
import { Link } from "react-router-dom";
import i18next, { t } from "i18next";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";

function UpcomingProjects() {
  useTranslation([]);
  const [fetch, setFetch] = useState([]);

  useEffect(() => {
    // Initialize AOS
    AOS.init({ once: true });

    // Handle initial language and language changes
    if (i18next.language === "en") {
      setFetch(upcomingData.projectsEN);
    } else {
      setFetch(upcomingData.projectsDE);
    }
  }, [i18next.language]);

  return (
    <>
      <section id="upcoming-projects" className="projects">
        <div className="container pt-5 pb-5 text-center">
          {/* Changed title to Upcoming Projects */}
          <h2 className="section-title">{t("UpcomingProjects") || "Upcoming Projects"}</h2>
          <div className="row">
            {fetch.map(({ id, link, img, timer, name }) => (
              <div
                className="col-md-4 col-sm-8"
                data-aos="fade-up"
                data-aos-duration={timer}
                key={id}
              >
                <Link to={`/${link}`} className="link">
                  <div className="box-image">
                    <div
                      className="image cover-full transition"
                      style={{ backgroundImage: `url(${img})` }}
                    ></div>
                    <div className="desc center">
                      <h4 style={{ fontSize: "19px" }}>{name}</h4>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default UpcomingProjects;